/* eslint-disable consistent-return */
/* eslint-disable no-unsafe-optional-chaining */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { setMessage } from 'redux/common/messageSlice';
import { SEVERITY_ERROR, USER, APCM } from 'utils/constants';
import { addToSecureStorage, addToStorage, removeFromSecureStorage } from 'utils/storage';
import { errorHandler, successHandler } from 'utils/errorHandler';
// eslint-disable-next-line import/no-cycle
import { setLiscenseLoading, signIn } from './authSlice';

export const signInAsync = createAsyncThunk(
    'app-login',
    async (data, { dispatch }) => {
        try {
            const response = await API.post(`${API_URL.login}`, {
                ...data.credentials,
                logged_by_service: APCM,
            });
            if (
                response.app_type.includes('APCM') ||
                response.app_type.includes('APCM_Authorizer') ||
                response.app_type.includes('APCM_Executor')
                //  && (response.user_role === 'APCM_Admin' ||
                // response.user_role === 'Authorizer' ||
                // response.user_role === 'Executor'  )
            ) {
                addToSecureStorage(USER, JSON.stringify(response));
                dispatch(signIn(response));
            } else {
                dispatch(
                    setMessage({
                        message: 'Invalid Apptype',
                        severity: SEVERITY_ERROR,
                    }),
                );
            }
        } catch (error) {
            dispatch(
                setMessage({
                    message: error.message,
                    severity: SEVERITY_ERROR,
                }),
            );
            return Promise.reject({ payload: error });
        }
    },
);

export const getLiscenseDetails = createAsyncThunk(
    'getLiscenseDetails',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { user } = session?.auth;
        const { token } = user;
        dispatch(setLiscenseLoading(true));
        try {
            const response = await API.get(API_URL.liscense, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 2,
            });
            dispatch(setLiscenseLoading(false));
            addToStorage('liscense', response);
            return response;
        } catch (error) {
            dispatch(setLiscenseLoading(false));
            dispatch(
                setMessage({
                    message: error.message,
                    severity: SEVERITY_ERROR,
                }),
            );
            return Promise.reject({ payload: error });
        }
    },
);

export const getGeneralSettings = createAsyncThunk(
    'getGeneralSettings',
    async (data, { dispatch }) => {
        try {
            const response = await API.get(API_URL.general_setting);
            return response;
        } catch (error) {
            dispatch(
                setMessage({
                    message: error.message,
                    severity: SEVERITY_ERROR,
                }),
            );
            return Promise.reject({ payload: error });
        }
    },
);

export const getTokenByUsername = createAsyncThunk(
    'getTokenByUsername',
    async (data, { dispatch }) => {
        try {
            const response = await API.post(API_URL.getTokenByUsername, {
                ...data,
                logged_by_service: APCM,
            });
            response.microsoftLogin = true;

            addToSecureStorage(USER, JSON.stringify(response));
            dispatch(signIn(response));
        } catch (error) {
            dispatch(
                setMessage({
                    message: error.message,
                    severity: SEVERITY_ERROR,
                }),
            );
            return Promise.reject({ payload: error });
        }
    },
);

export const signOutAsync = createAsyncThunk(
    'app-logout',
    async (data, { getState }) => {
        const session = getState();
        const { user } = session?.auth;
        const { email, token } = user;
        try {
            await API.post(
                API_URL.logout,
                {
                    email,
                    logged_by_service: APCM,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                }
            );
        } finally {
            removeFromSecureStorage(USER);
            window.parent.location.reload();
        }
    },
);

export const getCaptcha = createAsyncThunk(
    'getCaptcha',
    async (_, { dispatch }) => {
        try {
            const response = await API.get(
                `${API_URL.getCaptcha}`  
            );
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const verifyCaptcha = createAsyncThunk(
    'verifyCaptcha',
    async (data, { dispatch }) => {
        try {
            const response = await API.post(
                `${API_URL.verifyCaptcha}`,
                data,
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);